import React from 'react';
import { FaCheckCircle, FaUserGraduate, FaChartLine, FaHandshake, FaCertificate, FaUsers } from 'react-icons/fa';

const WhyChooseUs = () => {
  const benefits = [
    {
      icon: <FaUserGraduate className="text-4xl" />,
      title: 'Expert Instructors',
      description: 'Learn from industry professionals with real-world experience',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: <FaChartLine className="text-4xl" />,
      title: 'Career Growth',
      description: 'Bridge-to-corporate programs designed for successful placements',
      color: 'from-orange-500 to-orange-600'
    },
    {
      icon: <FaHandshake className="text-4xl" />,
      title: 'Industry Partnerships',
      description: 'Strong connections with top colleges and leading companies',
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: <FaCertificate className="text-4xl" />,
      title: 'Quality Training',
      description: 'Comprehensive curriculum with hands-on projects and mentoring',
      color: 'from-green-500 to-green-600'
    },
    {
      icon: <FaUsers className="text-4xl" />,
      title: 'Proven Track Record',
      description: '95% success rate with 500+ students placed in top companies',
      color: 'from-pink-500 to-pink-600'
    },
    {
      icon: <FaCheckCircle className="text-4xl" />,
      title: 'Job-Ready Skills',
      description: 'Focus on practical skills that employers are looking for',
      color: 'from-indigo-500 to-indigo-600'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white" data-testid="why-choose-us-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Vlinkin?</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We provide more than just training - we build careers and transform futures
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 border border-gray-100"
              data-testid={`benefit-card-${index}`}
            >
              <div className={`inline-flex p-4 rounded-lg bg-gradient-to-br ${benefit.color} text-white mb-6`}>
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;